<template>
    <transition :name="transitionName" v-show="modelValue">
        <div 
            v-on-click-outside="onCloseBtnClick"
            ref="fluidPopup" 
            class="vz-fluid-popup" 
            v-scroll="calculateListPosition"
            :class="{[variant]: true}" 
        >
        <div>
           <slot />
        </div>
        <vz-close-btn
            :height="20"
            :width="20"
            :size="16"
            @click="onCloseBtnClick"
        />
        </div>
    </transition>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';

const emit = defineEmits(['update:modelValue'])
const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
        required: true,
    },
    target: {
        type: Object as PropType<HTMLElement>,
        default: null,
        required: true,
    },
    
    transitionName: {
        type: String,
        default: 'fade'
    },
    variant: {
        type: String,
        default: ''
    },
    centered: {
        type: Boolean,
        default: false,
    },
    autoWidth: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
})
const fluidPopup = ref<any>(null)

watch(() => props.modelValue, (n) => {
    if ( n ) {
        nextTick( () => {
            calculateListPosition()
        })
    }
} )

function onCloseBtnClick() {
    emit('update:modelValue', false)
}

function calculateListPosition(): void {
    if (!props.target) {
        return
    }

    const rect = fluidPopup.value?.getBoundingClientRect()
    const { top, height, width, left } = props.target?.getBoundingClientRect() || { top: 0, height: 0, width: 0, left: 0 }
    if (rect) {
        const fullHeight = top + height + rect.height
        
        fluidPopup.value.style.left = props.centered ?  `${left - (rect.width / 2) + (width / 2 )}px`  : `${left}px`
        if ( props.autoWidth) {
            fluidPopup.value.style.width = `${width}px`
        }
        if (fullHeight > window.innerHeight) {
            fluidPopup.value.style.top = `${top - rect.height}px`
            // fluidPopup.value.style.boxShadow = '2px -2px 4px rgba(0, 0, 0, 0.15)'
        } else {
            fluidPopup.value.style.top = `${top + height}px`
            // fluidPopup.value.style.boxShadow = '0px 2px 4px rgba(0, 0, 0, 0.15)'
        }
    }
}
</script>